import Vue from 'vue'
import Confirm from './confirm'

Vue.use(Confirm)

export default new Confirm()